import { DataSource } from '@angular/cdk/collections';
import { BehaviorSubject } from 'rxjs';

export class McRAIDataSource<T> extends DataSource<T> {

  private readonly _data: BehaviorSubject<T[]>;

  constructor(
    private _initialData: T[] = []
  ) {
    super();
    this._data = new BehaviorSubject<T[]>(_initialData);
  }

  public connect(): BehaviorSubject<T[]> {
    return this._data;
  }

  public disconnect() { }
}
